
import React from 'react';

interface QuoteProps {
  text: string;
  className?: string;
  large?: boolean;
}

const Quote: React.FC<QuoteProps> = ({ text, className = "", large = false }) => {
  return (
    <div className={`max-w-4xl mx-auto px-6 text-center ${className}`}>
      <p className={`serif italic text-[#C9A227] leading-tight font-bold ${large ? 'text-3xl md:text-5xl' : 'text-xl md:text-3xl'}`}>
        "{text}"
      </p>
    </div>
  );
};

export default Quote;
